import { Navigate, Outlet } from "react-router";
import { useAuth } from "@/lib/auth-context";
import { Skeleton } from "@/components/ui/skeleton";

function AuthSkeleton() {
  return (
    <div className="flex min-h-dvh items-center justify-center">
      <div className="space-y-4 text-center">
        <Skeleton className="mx-auto h-10 w-10 rounded-full" />
        <Skeleton className="mx-auto h-4 w-48" />
      </div>
    </div>
  );
}

export function RequireAuth() {
  const { user, profile, isLoading } = useAuth();

  if (isLoading) {
    return <AuthSkeleton />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // A comp is an admin-granted access flag, independent of any Stripe
  // subscription — it bypasses the subscription checks entirely, until its end
  // date. Admin comps have none; the storm-ad free month ends after 30 days
  // (055), and then the subscription checks below decide as usual.
  const comped =
    profile?.comp_enabled === true &&
    (!profile.comp_expires_at || new Date(profile.comp_expires_at) > new Date());

  if (!import.meta.env.DEV && !comped) {
    // No profile or no subscription source => expired
    if (!profile?.subscription_source) {
      return <Navigate to="/expired" replace />;
    }

    // Subscription period ended
    if (
      profile.subscription_period_end &&
      new Date(profile.subscription_period_end) < new Date()
    ) {
      return <Navigate to="/expired" replace />;
    }
  }

  return <Outlet />;
}
